// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1TuUL","form":"styles_form__liJYg"};